<template>
  <DefaultLayout>
    <div slot="content">
      <!-- FEATURE LIMITED DIALOG-->
      <v-dialog v-model="featureLimitedModal" width="400" persistent>
        <v-card>
          <v-card-title>Feature limited</v-card-title>
          <v-card-text>{{featureLimitedText || featureLimitedDefaultText}}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn tile text color="blue" @click="featureLimitedModal = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- END FEATURE LIMITED DIALOG-->
      <!-- ASSIGN REQUESTS DIALOG-->
      <v-dialog v-model="assignModal" width="400">
        <v-card>
          <v-card-title>Assign request</v-card-title>
          <v-card-text>
            <v-form ref="assignForm">
              <v-select id="assign-requests-team" dense :items="organization.accounts" v-model="assignSelectedTeam" label="Select team" item-text="name" item-value="accountId" @change="assignTeamChange"></v-select>
              <v-select id="assign-requests-user"
                        dense multiple
                        :items="assignTeamUsers"
                        v-model="assignSelectedUsers"
                        label="Select Users"
                        :item-text="userNameText"
                        item-value="userId">
                <template v-slot:selection="{ item, index }">
                  <span v-if="index === 0">{{ item.firstName }} {{ item.lastName }}</span>
                  <span v-if="index === 1" class="grey--text caption">(+{{ assignSelectedUsers.length - 1 }} others)</span>
                </template>
              </v-select>
              <v-text-field id="assign-requests-note" v-model="assignNote" label="Note" type="text"></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn tile text color="blue" @click="assignModal = false">Close</v-btn>
            <v-btn id="assign-requests-assign" tile dark depressed color="blue" @click="assignRequests">Assign</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- END ASSIGN REQUESTS DIALOG-->

      <!-- CLOSE REQUESTS DIALOG-->
      <v-dialog v-model="closeModal" width="400">
        <v-card>
          <v-card-title>Close Selected Requests</v-card-title>
          <v-card-text>
            <v-form ref="closeRequestsRef">
              <v-radio-group v-model="selectedOutcome" row>
                <v-radio v-for="n in outcome" :key="n.value" :label="n.text" :value="n.value" :id="`close-requests-${n.value}`" ></v-radio>
              </v-radio-group>
              <v-select v-if="selectedOutcome === 2 && account.declinedReasons && account.declinedReasons.length"
                        id="close-requests-reason"
                        :items="account.declinedReasons"
                        v-model="selectedDeclineReason"
                        label="Select Decline Reason"
                        item-text="declinedReason"
                        item-value="reasonId">
              </v-select>
              <v-text-field id="close-requests-note" v-model="closeNote" label="Note (optional)" type="text"></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn tile text color="blue" @click="closeModal = false">Cancel</v-btn>
            <v-btn id="close-requests-close" tile dark depressed color="blue" @click="closeRequests">Close Requests</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- END CLOSE REQUESTS DIALOG-->

      <!-- ADD REQUEST DIALOG-->
      <v-dialog v-model="dialogAddRequest" width="600" scrollable>
        <v-card>
          <v-card-title class="align-center">
            <span>New profile request</span>
            <span v-if="credits !== null" class="caption font-weight-regular ml-4 grey--text text--lighten-1 pt-1">
              {{ credits }} {{ credits === 1 ? 'credit' : 'credits' }} remaining
            </span>
          </v-card-title>
          <v-card-text>
            <v-form ref="requestForm">
              <v-select :items="templates"
                        id="new-request-template"
                        item-text="name"
                        item-value="id"
                        v-model="template"
                        @change="changeTemplate"
                        label="Template Name">
              </v-select>
              <template v-for="r in references">
                <v-text-field :key="r.ordinal"
                              v-model="r.value"
                              :id="`new-request-reference-${r.ordinal}`"
                              :label="r.name"
                              type="text"
                              :rules="[validateRequiredRule]">
                </v-text-field>
              </template>
              <v-row>
                <v-col cols="12" sm="6" class="py-0">
                  <v-text-field v-model="fname"
                                id="new-request-first-name"
                                class="mr-1"
                                label="First Name (optional)"
                                type="text"
                                :rules="docusignItems.length ? [validateRequiredRule] : []">
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="6" class="py-0">
                  <v-text-field v-model="lname"
                                id="new-request-last-name"
                                label="Last Name (optional)"
                                type="text"
                                :rules="docusignItems.length ? [validateRequiredRule] : []">
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6" class="py-0">
                  <v-text-field v-model="email"
                                id="new-request-email"
                                class="mr-1"
                                label="Email address (optional)"
                                type="email"
                                ref="email"
                                :rules="[validateEmailRule]">
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="6" class="py-0">
                  <v-text-field v-model="mobile"
                                id="new-request-mobile"
                                label="Mobile number (optional)"
                                type="text"
                                :rules="[validateMobileRule]">
                  </v-text-field>
                </v-col>
              </v-row>
              <v-textarea v-model="message"
                          id="new-request-message"
                          label="Message (optional)"
                          rows="2"
                          auto-grow>
              </v-textarea>
              <template v-for="item in docusignItems">
                <div v-if="item.signers.length" :key="item.id">
                  <div>{{item.name}}</div>
                  <v-row v-for="signer in item.signers" :key="signer.id">
                    <v-col cols="12" sm="4">
                      <strong>{{signer.roleName}}</strong>
                    </v-col>
                    <v-col cols="12" sm="4">
                      <v-text-field v-model="signer.email"
                                    class="mr-1"
                                    label="Email"
                                    type="text"
                                    :rules="[validateRequiredRule, validateEmailRule]">
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4">
                      <v-text-field v-model="signer.userName"
                                    class="mr-1"
                                    label="Username"
                                    type="text"
                                    :rules="[validateRequiredRule]">
                      </v-text-field>
                    </v-col>
                  </v-row>
                </div>
              </template>
              <el-upload ref="requestAttachment"
                        id="new-request-upload"
                        drag
                        action=""
                        :auto-upload="false"
                        :show-file-list="true"
                        :multiple="false"
                        :file-list="files"
                        :on-change="calculateFileUploadFilesSize"
                        :on-remove="calculateFileUploadFilesSize">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">Drop attachment file here or <em>click to add</em></div>
              </el-upload>
              <div v-if="filesSizeExceeded" class="files-size-exceeded">{{ filesSizeExceeded }}</div>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn tile text color="blue" @click="dialogAddRequest = false">Close</v-btn>
            <v-btn tile depressed dark color="blue" id="new-request-send" @click="addProfileRequest" :disabled="!!filesSizeExceeded">Send</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- END ADD REQUEST DIALOG-->

      <div class="d-flex align-center mb-3">
        <div class="title">Guest Requests</div>
        <span class="mx-4"> / </span>
        <v-btn-toggle v-model="requestsTabsToggler" tile group mandatory class="requests-switcher">
          <v-btn :ripple="false">Open</v-btn>
          <v-btn :ripple="false">Archived</v-btn>
          <v-btn :ripple="false">To purge</v-btn>
        </v-btn-toggle>
        <v-spacer></v-spacer>
        <v-btn v-if="$store.getters.isProfileRequestCreator"
                id="new-request-button"
                class="ml-3 new-request-btn"
                tile small depressed color="blue"
                :disabled="credits === null"
                @click="newProfileRequest">
          <v-icon small left>fal fa-paper-plane</v-icon>
          New Guest Request
        </v-btn>
        <v-menu v-if="$store.getters.isProfileRequestCreator && $store.getters.isProfileRequestCSVUploader"
                left offset-y
                id="request-menu-dropdown">
        </v-menu>
      </div>
      <v-divider></v-divider>

      <!-- REQUEST FILTERS -->
      <v-row class="mt-2">
        <v-col>
          <v-select dense
                    class="body-2"
                    :items="datesRelative"
                    prepend-icon="date_range"
                    id="filter-date-select"
                    item-value="value"
                    v-model="datesRelativeSelected"
                    @change="updateRelativeDate"
                    label="Filter by date">
          </v-select>
        </v-col>
        <v-col>
          <v-select :items="preparedRequesters"
                    v-model="selectedUsersModel"
                    class="body-2"
                    prepend-icon="people"
                    item-value="id" item-text="name"
                    id="filter-user-select"
                    @change="updateUsers"
                    label="Filter by requester"
                    multiple dense>
            <template v-slot:selection="{ item, index }">
              <span v-if="index === 0">{{ item.name }}</span>
              <span v-if="index === 1" class="ml-1 grey--text caption">(+{{ selectedUsers.length - 1 }} others)</span>
            </template>
          </v-select>
        </v-col>
        <v-col v-if="requestsTabsToggler === 0">
          <v-select :items="requestStatuses"
                    class="body-2"
                    prepend-icon="label"
                    id="filter-status-select"
                    item-text="text"
                    item-value="value"
                    v-model="selectedStatuses"
                    @change="updateStatuses"
                    label="Filter by status"
                    multiple dense>
            <template v-slot:selection="{ item, index }">
              <span v-if="index === 0">{{ item.text }}</span>
              <span v-if="index === 1" class="ml-1 grey--text caption">(+{{ selectedStatuses.length - 1 }} others)</span>
            </template>
          </v-select>
        </v-col>
        <v-col>
          <v-text-field v-model="search"
                        class="body-2"
                        id="filter-search-result"
                        prepend-icon="search"
                        dense clearable
                        label="Search..."
                        @input="filterChange">
          </v-text-field>
        </v-col>
      </v-row>
      <!-- END REQUEST FILTERS -->

      <!-- REQUESTS LIST -->
      <v-data-table v-if="requests && requests.length && !loading"
                    v-model="selected"
                    :headers="headers"
                    :items="preparedRequests"
                    :search="filterText"
                    item-key="id" show-select
                    :footer-props="{
                      itemsPerPageOptions: [10, 20, 50, { text: 'All', value: -1 }],
                      showFirstLastPage: false,
                      prevIcon: 'fal fa-chevron-left',
                      nextIcon: 'fal fa-chevron-right',
                      itemsPerPageText: 'Requests per page'
                    }"
                    :hide-default-footer="preparedRequests.length < 11"
                    class="requests-list-table">
        <template v-slot:top="{ pagination, options, updateOptions }">
          <!-- REQUEST ACTIONS -->
          <div class="d-flex requests-action-buttons">
            <!-- <v-btn v-if="$store.getters.isProfileRequestResender"
                  id="button-resent-request"
                  :disabled="!selected.length"
                  tile outlined small color="blue"
                  @click="resendRequests">
              <v-icon small left dark>fal fa-paper-plane</v-icon>Resend
            </v-btn> -->
            <v-btn v-if="$store.getters.isProfileRequestAssigner"
                  id="button-assign-request"
                  :disabled="!selected.length"
                  tile outlined small color="blue" class="ml-3"
                  @click="assignRequest">
              <v-icon small left dark>fal fa-share</v-icon>Assign
            </v-btn>
            <v-btn v-if="$store.getters.isProfileRequestEditor && requestsTabsToggler === 0"
                  id="button-close-request"
                  :disabled="!isCloseAllowed"
                  tile outlined small color="blue" class="ml-3"
                  @click="closeModal = true">
              <v-icon small left dark>fal fa-box-check</v-icon> Close
            </v-btn>
            <v-btn v-if="$store.getters.isProfileRequestCanceller && requestsTabsToggler === 0"
                  id="button-cancel-request"
                  :disabled="!isCancelAllowed"
                  tile small outlined color="blue" class="ml-3"
                  @click="cancelRequests">
              <v-icon small left dark>fal fa-times</v-icon> Cancel
            </v-btn>
            <v-btn id="button-purge-request"
                  v-if="$store.getters.isAccountAdminViewer && requestsTabsToggler === 1"
                  :disabled="!isPurgeArchivedAllowed"
                  tile small outlined color="blue" class="ml-3"
                  @click="purgeArchivedRequests">
              <v-icon small left dark>fal fa-shredder</v-icon> Purge
            </v-btn>
            <v-btn id="button-purge-now-request"
                  v-if="$store.getters.isAccountAdminViewer && requestsTabsToggler === 2"
                  :disabled="!isPurgeNowAllowed"
                  tile small outlined color="blue" class="ml-3"
                  @click="purgeNow">
              <v-icon small left dark>fal fa-shredder</v-icon> Purge now
            </v-btn>
          </div>
          <!-- END REQUEST ACTIONS -->
          <v-data-footer 
            :pagination="pagination" 
            :options="options"
            :itemsPerPageOptions="[10, 20, 50, { text: 'All', value: -1 }]"
            :showFirstLastPage="false"
            prevIcon="fal fa-chevron-left"
            nextIcon="fal fa-chevron-right"
            @update:options="updateOptions"
            items-per-page-text="Requests per page" />
        </template>
        <!-- Status column -->
        <template v-slot:item.filled="{ item }">
          <router-link :to="{ name: 'Profile Request', params: { id: item.id }}">
            <template v-if="item.status === 1">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-progress-circular v-on="on" :rotate="270" :size="16" :width="8" :value="item.filled" class="mr-2" color="orange" ></v-progress-circular>
                  </template>
                  <span>{{item.filled}}%</span>
                </v-tooltip>
                <span :class="{'font-weight-bold': !item.viewed}">{{ item.filledCount }}/{{ item.requestedCount }}</span>
                <span></span>
            </template>
            <template v-if="item.status === 2">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" small color="red">fal fa-times</v-icon>
                </template>
                <span>Canceled</span>
              </v-tooltip>
            </template>
            <template v-if="item.status === 3">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" small color="blue" class="mr-2">fal fa-check</v-icon>
                </template>
                <span>Completed</span>
              </v-tooltip>
              <span :class="{'font-weight-bold': !item.viewed}">{{ item.filledCount }}/{{ item.requestedCount }}</span>
            </template>
            <template v-if="item.status === 4">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" small color="red">fal fa-hand-rock</v-icon>
                </template>
                <span>Revoked</span>
              </v-tooltip>
            </template>
            <template v-if="item.status === 5">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" small color="blue" class="mr-2">fal fa-user-times</v-icon>
                </template>
                <span>Deleted</span>
              </v-tooltip>
            </template>
            <template v-if="item.status === 6">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" small color="blue" class="mr-2">fal fa-cabinet-filing</v-icon>
                </template>
                <span>Archived</span>
              </v-tooltip>
            </template>
            <template v-if="item.status === 7">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" small color="blue" class="mr-2">fal fa-shredder</v-icon>
                </template>
                <span>Purge</span>
              </v-tooltip>
            </template>
            <template v-if="item.status === 8">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" small color="red" class="mr-2">fal fa-shredder</v-icon>
                </template>
                <span>Purged</span>
              </v-tooltip>
            </template>
            <template v-if="item.status === 9">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" small color="red" class="mr-2">fal fa-hand-paper</v-icon>
                </template>
                <span>Rejected</span>
              </v-tooltip>
            </template>
            <template v-if="item.status === 10">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" small color="blue" class="mr-2">fal fa-thumbs-up</v-icon>
                </template>
                <span>Accepted</span>
              </v-tooltip>
            </template>
            <template v-if="item.status === 11">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" small color="red" class="mr-2">fal fa-calendar-times</v-icon>
                </template>
                <span>Expired</span>
              </v-tooltip>
            </template>
            <template v-if="item.status === 12">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" small color="blue" class="mr-2">fal fa-shredder</v-icon>
                </template>
                <span>Purge Requested</span>
              </v-tooltip>
            </template>
          </router-link>
        </template>
        <!-- END Status column -->
        <!-- Date/Time column -->
        <template v-slot:item.formattedCreated="{ item }">
          <router-link :to="{ name: 'Profile Request', params: { id: item.id }}">
            <span :class="{'font-weight-bold': !item.viewed}">{{item.formattedCreated}}</span>
          </router-link>
        </template>
        <!-- END Date/Time column -->
        <!-- Requester column -->
        <template v-slot:item.requester="{ item }">
          <router-link :to="{ name: 'Profile Request', params: { id: item.id }}">
            <span :class="{'font-weight-bold': !item.viewed}">{{item.requester}}</span>
          </router-link>
        </template>
        <!-- END Requester column -->
        <!-- Reference column -->
        <template v-slot:item.preparedReference="{ item }">
          <router-link :to="{ name: 'Profile Request', params: { id: item.id }}">
            <span :class="{'font-weight-bold': !item.viewed}">{{item.preparedReference}}</span>
          </router-link>
        </template>
        <!-- END Reference column -->
        <!-- Assigned column -->
        <template v-slot:item.assigned="{ item }">
          <router-link :to="{ name: 'Profile Request', params: { id: item.id }}">
            <span v-for="(user, i) in item.assigned" :key="i" class="mr-2">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-avatar color="teal" size="24" v-on="on">
                    <span class="body-1 white--text headline">{{ user.charAt(0).toUpperCase() }}</span>
                  </v-avatar>
                </template>
                <span>{{ user }}</span>
              </v-tooltip>
            </span>
          </router-link>
        </template>
        <!-- END Assigned column -->
      </v-data-table>
      <div v-if="loading" class="text-center pt-12 mt-12 headline">
          <v-progress-circular
            indeterminate
            color="blue-grey"
            width=2
            size=50></v-progress-circular>
      </div>
      <div v-if="!requests.length && !loading" class="text-center pt-12 mt-12 headline font-weight-bold grey--text">
        No requests match the currently applied filters
      </div>
      <!-- END REQUESTS LIST -->
    </div>
  </DefaultLayout>
</template>

<script>
import uuidv4 from 'uuid/v4';
import { mapState } from 'vuex';
import {
  CHECK_ORGANIZATIONS,
  GET_ANON_REQUESTS,
  CREATE_ANON_REQUEST,
  CREATE_REQUESTS_CSV,
  GET_TEMPLATES,
  GET_CREDITS,
  RESEND_REQUESTS,
  ASSIGN_REQUESTS,
  CANCEL_REQUESTS,
  CLOSE_REQUESTS,
  PURGE_REQUESTS_IMMEDIATELY,
  PURGE_ARCHIVED_REQUESTS,
  GET_ESIGNTEMPLATES_SIGNERS,
} from '@/store/actions.type';
import DefaultLayout from '@/layouts/DefaultLayout';

export default {
  name: 'profile-requests',
  components: {
    DefaultLayout,
  },
  props: {
    caption: {
      type: String,
      default: 'Data Requests',
    },
  },
  data() {
    return {
      fullTemplate: null,
      references: [],
      requestsTabsToggler: 0,
      selectedUsers: [],
      selectedUsersModel: [],
      datesRelativeSelected: 43200,
      datesRelative: [
        { value: 30, text: 'Last 30 minutes' },
        { value: 60, text: 'Last 1 hour' },
        { value: 120, text: 'Last 2 hours' },
        { value: 480, text: 'Last 8 hours' },
        { value: 1440, text: 'Last 1 day' },
        { value: 2880, text: 'Last 2 days' },
        { value: 10080, text: 'Last 7 days' },
        { value: 20160, text: 'Last 14 days' },
        { value: 43200, text: 'Last 1 month' },
        { value: 86400, text: 'Last 2 months' },
        { value: 0, text: 'All requests' },
      ],
      requestStatuses: [
        { value: 1, text: 'Pending' },
        { value: 3, text: 'Completed' },
      ],
      selectedStatuses: [1, 3],
      outcome: [ {value: 1, text: 'Approved'}, {value: 2, text: 'Declined'}],
      selectedOutcome: 1,
      closeNote: '',
      selectedDeclineReason: null,
      featureLimitedModal: false,
      featureLimitedText: '',
      featureLimitedDefaultText: 'To enable this feature, you need to upgrade your price plan.',
      closeModal: false,
      assignModal: false,
      assignSelectedTeam: null,
      assignTeamUsers: [],
      assignSelectedUsers: [],
      assignNote: '',
      selected: [],
      headers: [
        { text: 'Status', value: 'filled', align: 'left', width: '100px' },
        { text: 'Created', value: 'formattedCreated', align: 'left' },
        { text: 'Requester', value: 'requester', align: 'left' },
        { text: 'Reference', value: 'preparedReference', align: 'left' },
        { text: 'Assigned', value: 'assigned', align: 'left' },
      ],
      search: '',
      dialogAddRequest: false,
      selectedCsvFile: null,
      docusignItems: [],
      csvFileError: false,
      csvFileErrorText: '',
      csvRequests: [],
      credits: null,
      loading: true,
      template: null,
      fname:'',
      lname:'',
      email:'',
      mobile:'',
      message:'',
      files: [],
      filesSizeExceeded: '',
      s_email: '',
      columns: [
        { key: 'status', label: 'Status', sortable: true },
        { key: 'created', label: 'Date/Time', sortable: true },
        { key: 'requester', label: 'Requester', sortable: true },
        { key: 'reference', label: 'Reference', sortable: true },
        { key: 'requested', label: 'Client', sortable: true },
        { key: 'assigned', label: 'Assigned', sortable: true },
        { key: 'actions', label: 'Actions' },
      ],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      modalInfo: { title: '', content: '' },
      outlined: false,
      striped: true,
      hover: true,
      bordered: true,
      requests: [],
      validateRequiredRule: v => !!v || 'This field is required',
      validateEmailRule: v => {
        // eslint-disable-next-line
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return (!v || re.test(String(v).toLowerCase())) || 'Please enter valid Email';
      },
      validateMobileRule: v => {
        const re = /^[+]+(?:[\d-.\s()]*)$/;
        return (!v || re.test(String(v).toLowerCase())) || 'Include + country code';
      },
    };
  },
  computed: {
    ...mapState({ requestsStore: state => state.profileRequests.profileRequests }),
    ...mapState({ filterText: state => state.profileRequests.profileRequestsFilterText }),
    ...mapState({ selectedStoreStatuses: state => state.profileRequests.selectedStatuses }),
    ...mapState({ selectedStoreUsers: state => state.profileRequests.selectedUsers }),
    ...mapState({ selectedStoreDate: state => state.profileRequests.selectedRelativeTime }),
    ...mapState({ organization: state => state.organizations.userSelectedOrganization }),
    ...mapState({ limitations: state => state.organizations.userSelectedOrganization.limitations }),
    ...mapState({ account: state => state.organizations.userSelectedAccount }),
    ...mapState({ templates: state => state.profileTemplates.selectedAccountTemplates }),
    ...mapState({ signedInUser: state => state.auth.account }),
    isCloseAllowed() {
      return this.selected.length ? !this.selected.some(x => x.status !== 3 && x.status !== 1) : false;
    },
    isCancelAllowed() {
      return this.selected.length ? !this.selected.some(x => x.status !== 1 || x.filled > 0 ) : false;
    },
    isPurgeArchivedAllowed() {
      return this.selected.length ? !this.selected.some(x => x.status !== 6) : false;
    },
    isPurgeNowAllowed() {
      return this.selected.length ? !this.selected.some(x => x.status !== 7) : false;
    },
    preparedRequests() {
      return this.requests.map(request => {
        const splitCreated = request.created.split(' ');
        let preparedReference = '';
        if (request.reference && request.reference.length) {
          preparedReference = Array.isArray(request.reference) ? request.reference.join(', ') : request.reference;
        }
        const splitDate = splitCreated[0].split('/');
        const formattedDate = `${splitDate[1]}/${splitDate[0]}/${splitDate[2]}`;
        const { assigned } = request;
        const userList = [];
        if(assigned){
          assigned.forEach(userId => {
            const user = this.account.users.find(user => user.userId === userId);
            if (user) {
              userList.push(`${user.firstName} ${user.lastName}`);
            }
          })
        }
        return {
          ...request,
          formattedCreated: `${formattedDate} ${splitCreated[1]}`,
          preparedReference,
          assigned: userList,
        };
      });
    },
    preparedRequesters() {
      const signedInUser = {
        id: this.signedInUser.loggedInUserId,
        name: `${this.signedInUser.loggedInUserFirstName} ${this.signedInUser.loggedInUserLastName}`,
      };
      const requesters = [];
      this.requestsStore.forEach(request => {
        const requester = {
          id: request.requesterId,
          name: request.requester,
        };
        if (requesters.find(req => req.id === requester.id)) {
          return;
        }
        requesters.push(requester);
      });
      if (!requesters.find(req => req.id === signedInUser.id)) {
        requesters.push(signedInUser);
      }
      requesters.sort((a, b) => a.name > b.name ? 1 : b.name > a.name ? -1 : 0);
      requesters.unshift({ id: 'all', name: 'Select all' });
      return requesters;
    },
    templatesNoDocusign() {
      return this.templates.filter(template => {
        let noDocusign = true;
        template.items.forEach(item => {
          if (item.itemType === 5) {
            noDocusign = false;
          }
        })
        return noDocusign;
      });
    }
  },
  watch: {
    account() {
      this.fetchRequests();
      this.fetchCredits();
    },
    requestsStore() {
      this.filterRequests();
    },
    dialogAddRequest(newVal) {
      if (!newVal) {
        this.filesSizeExceeded = '';
        this.$refs.requestForm.resetValidation();
      }
    },
    requestsTabsToggler(val) {
      this.selected = [];
      if (val === 1) {
        this.selectedStatuses = [6];
      } else if (val === 2) {
        this.selectedStatuses = [7];
      } else {
        this.selectedStatuses = [1, 3];
      }
      this.updateStatuses();
    },
    featureLimitedModal(val) {
      if (!val) {
        this.featureLimitedText = '';
      }
    },
  },
  methods: {
    userNameText(item) {
      return item.firstName + ' ' + item.lastName;
    },
    calculateFileUploadFilesSize() {
      const maxSize = 25 * 1024 * 1024; // MAX size 25 Mb
      let size = 0;
      this.$refs.requestAttachment.uploadFiles.forEach(file => {
        size += file.size;
      });
      if (size > maxSize) {
        this.filesSizeExceeded = 'The total size of all files should not exceed 25 MB.';
      } else {
        this.filesSizeExceeded = '';
      }
    },
    async fetchCredits(){
      const response = await this.$store.dispatch(GET_CREDITS, this.organization.id);
      this.credits = response.availableCredits;
    },
    usersTextValue(val) {
      return `${val.firstName} ${val.lastName}`;
    },
    updateRelativeDate(value) {
      this.$store.commit('UPDATE_REQUEST_DATE_FILTER', value);
      this.fetchRequests();
    },
    updateUsers(value) {
      if (this.selectedUsers.indexOf('all') === -1 && value.indexOf('all') > -1) {
        this.selectedUsersModel = this.preparedRequesters.map(user => user.id);
      } else if (this.selectedUsers.indexOf('all') > -1 && value.indexOf('all') === -1) {
        this.selectedUsersModel = [];
      } else if (value.length === this.preparedRequesters.length - 1 && value.indexOf('all') === -1) {
        this.selectedUsersModel = this.preparedRequesters.map(user => user.id);
      } else if (value.length < this.preparedRequesters.length && value.indexOf('all') > -1) {
        const allIndex = this.selectedUsersModel.indexOf('all');
        this.selectedUsersModel.splice(allIndex, 1);
      }
      this.selectedUsers = [...this.selectedUsersModel];
      this.$store.commit('UPDATE_REQUEST_USERS_FILTER', this.selectedUsers);
      this.filterRequests();
    },
    updateStatuses() {
      this.$store.commit('UPDATE_REQUEST_STATUSES_FILTER', this.selectedStatuses);
      this.filterRequests();
    },
    getReferenceIndex(index) {
      return index ? ` (${index+1})` : '';
    },
    assignRequest() {
      this.assignSelectedTeam = this.account.accountId;
      this.assignTeamUsers = this.organization.accounts.find(x => x.accountId == this.assignSelectedTeam).users;
      this.assignModal = true;
    },
    assignTeamChange() {
      this.assignTeamUsers = this.organization.accounts.find(x => x.accountId == this.assignSelectedTeam).users;
    },
    checkTemplateHasDocusign(template) {
      const docusignItems= [];
      if (template.items && template.items.length) {
        template.items.forEach(item => {
          if (item.itemType === 5) {
            docusignItems.push(item);
          }
        });
      }
      if (docusignItems.length) {
        docusignItems.forEach(async (item, i) => {
          try {
            const response = await this.$store.dispatch(GET_ESIGNTEMPLATES_SIGNERS, item.id);
            item.signers = [ ...response ];
            if (docusignItems.length === i + 1) {
              this.docusignItems = [ ...docusignItems ];
            }
          } catch(err) {
            this.$notify({
              type: 'error',
              title: 'Error',
              text: 'Error getting Signers. Please contact support@planetverify.com',
            });
          }
        });
      } else {
        this.docusignItems = [];
      }
    },
    changeTemplate() {
      const selectedTemplate = this.templates.find(x => x.id === this.template);
      this.references = selectedTemplate.references;
      this.checkTemplateHasDocusign(selectedTemplate);
    },
    filterChange(val) {
      this.$store.commit('UPDATE_FILTER_TEXT', val);
    },
    async resendRequests() {
      if (confirm('Resend selected requests?')) {
        const requestIds = [];
        this.selected.forEach(request => requestIds.push(request.id));
        try {
          await this.$store.dispatch(RESEND_REQUESTS, { profilesId: requestIds });
          this.$notify({
            type: 'success',
            title: 'Success',
            text: 'Requests resent',
          });
          this.selected = [];
        } catch (err) {
          this.$notify({
            type: 'error',
            title: 'Error',
            text: 'Something went wrong - please contact support@planetverify.com',
          });
        }
      }
    },
    async cancelRequests() {
      if (confirm('Cancel selected requests?')) {
        const requestIds = []
        this.selected.forEach(el => requestIds.push(el.id));
        try {
          await this.$store.dispatch(CANCEL_REQUESTS, { profilesId: requestIds });
          this.selected = [];
          this.fetchRequests();
          this.$notify({
            type: 'success',
            title: 'Success',
            text: 'Requests canceled',
          });
        } catch(err) {
          this.$notify({
            type: 'error',
            title: 'Error',
            text: 'Error canceling request. Please contact support@planetverify.com',
          });
        }
      }
    },
    async purgeArchivedRequests() {
      if (confirm('Purge archived requests?')) {
        const requestIds = [];
        this.selected.forEach(el => {
          requestIds.push(el.id);
        });

        try {
          await this.$store.dispatch(PURGE_ARCHIVED_REQUESTS, { ids: requestIds });
          this.$notify({
            type: 'success',
            title: 'Success',
            text: 'Requests sent to purge',
          });
          this.selected = [];
          setTimeout(() => {
            this.fetchRequests();
          }, 2000);
        } catch(err) {
          this.$notify({
            type: 'error',
            title: 'Error!',
            text: 'Error purging requests. Please contact support@planetverify.com',
          });
        }
      }
    },
    async purgeNow(){
      if (confirm('Purge requests immediately?')) {
        const requestIds = [];
        this.selected.forEach(el => {
          requestIds.push(el.id);
        });
        try {
          await this.$store.dispatch(PURGE_REQUESTS_IMMEDIATELY, { ids: requestIds });
          this.$notify({
            type: 'success',
            title: 'Success',
            text: 'Requests purged',
          });
          this.selected = [];
        } catch(err) {
          this.$notify({
            type: 'error',
            title: 'Error',
            text: 'Error purging requests. Please contact support@planetverify.com',
          });
        }
      }
    },
    async closeRequests() {
      const requestIds = [];
      this.selected.forEach(el => {
        requestIds.push(el.id);
      });
      const rToClose = {
        profileIds: requestIds,
        outcome: this.selectedOutcome,
        note: this.closeNote,
      };
      if (this.selectedDeclineReason !== null) {
        rToClose.customDeclineReasonId = this.selectedDeclineReason;
      }

      try {
        await this.$store.dispatch(CLOSE_REQUESTS, rToClose);
        this.$notify({
          type: 'success',
          title: 'Success',
          text: 'Requests closed',
        });
        this.selected = [];
        setTimeout(() => {
          this.fetchRequests();
        }, 2000);
      } catch(err) {
        this.$notify({
          type: 'error',
          title: 'Error!',
          text: 'Error closing requests. Please contact support@planetverify.com',
        });
      }
      this.closeModal = false;
    },
    assignRequests(){
        if (!this.assignSelectedUsers.length) {
          this.$notify({
            type: 'error',
            title: 'Error',
            text: 'Select at least one user',
          });
          return;
        }
        let requestIds = []
        this.selected.forEach(function(el){
            requestIds.push(el.id)
        })
        this.$store.dispatch(ASSIGN_REQUESTS, { profilesId: requestIds, teamId: this.assignSelectedTeam, assignedUsersId: this.assignSelectedUsers, note: this.assignNote }).then(() => {
          this.$notify({
            type: 'success',
            title: 'Success',
            text: 'Requests assigned',
          });
          this.selected = [];
        }, () => {
          this.$notify({
            type: 'error',
            title: 'Error',
            text: 'Something went wrong - please contact support@planetverify.com',
          });
        })
        this.assignModal = false
    },
    async fetchRequests() {
      this.loading = true
      try {
        const reqParams = {
          account: this.account.accountId,
          from: this.getCurrentDateTimeDelta(),
          to: Date.now()
        }
        await this.$store.dispatch(GET_ANON_REQUESTS, reqParams);
        this.loading = false
      } catch(err) {
        this.loading = false
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Something went wrong - please contact support@planetverify.com',
        });
      }
    },
    filterRequests() {
      const statuses = this.selectedStatuses && this.selectedStatuses.length ? this.selectedStatuses : [1, 3];
      const users = this.selectedUsers && this.selectedUsers.length > 0 ? [...this.selectedUsers] : this.preparedRequesters.map(user => user.id);
      const allIndex = users.indexOf('all');
      if (allIndex > -1) {
        users.splice(allIndex, 1);
      }
      this.requests = this.requestsStore.filter(x => {
        return statuses.includes(x.status) && users.includes(x.requesterId);
      });
    },
    getCurrentDateTimeDelta() {
      var today = Date.now();
      if (this.datesRelativeSelected == 0) {
        today = today - 999999999999;
      } else {
        today = today - this.datesRelativeSelected * 60000;
      }
      return today;
    },
    newProfileRequest() {
      if (!this.account.users.some(x => x.userId === this.$store.state.auth.account.loggedInUserId)) {
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'You are not in the current team.',
        });
        return;
      }
      if (this.credits === 0) {
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Insufficient credits remaining.',
        });
        return;
      }
      if (!this.templates.length) {
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'You need to first create a template.',
        });
        return;
      }
      this.template = this.templates[0].id;
      this.fullTemplate = this.templates[0];
      this.fname = '';
      this.lname = '';
      this.email = '';
      this.mobile = '';
      this.message = '';
      this.files = [];
      this.references = this.fullTemplate.references;
      this.checkTemplateHasDocusign(this.templates[0]);
      this.dialogAddRequest = true;
    },
    async addProfileRequest() {
      if (this.$refs.requestForm.validate()) {
        if (!this.template) {
          this.$notify({
            type: 'error',
            title: 'Error',
            text: 'Please select a template',
          });
          return;
        }

        var newRequest = new FormData();
        this.$refs.requestAttachment.uploadFiles.forEach(f => {
          newRequest.append('attachments', f.raw)
        });

        newRequest.append('id', uuidv4());
        newRequest.append('organizatonId', this.organization.id);
        newRequest.append('accountId', this.account.accountId);
        newRequest.append('templateId', this.template);
        newRequest.append('recipientEmail', this.email);
        newRequest.append('recipientMobile', this.mobile);
        newRequest.append('recipientFirstName', this.fname);
        newRequest.append('recipientLastName', this.lname);
        newRequest.append('note', this.message);
        this.references.forEach(e => {
          newRequest.append('references[]', JSON.stringify({
            name: e.name,
            ordinal: e.ordinal,
            value: e.value
          }));
        });

        if (this.docusignItems.length) {
          this.docusignItems.forEach(template => {
            const eSign = {
              templateId: template.id,
              eSigners: [],
            };

            template.signers.forEach(signer => {
              eSign.eSigners.push({
                recipientId: signer.recipientId,
                email: signer.email,
                userName: signer.userName,
              });
            });
            newRequest.append('esigns[]', JSON.stringify(eSign));
          });
        }
        try {
          await this.$store.dispatch(CREATE_ANON_REQUEST, newRequest);
          this.$notify({
            type: 'success',
            title: 'Success',
            text: 'Requests created',
          });
        } catch(err) {
          this.$notify({
            type: 'error',
            title: 'Error',
            text: 'Error creating request. Please contact support@planetverify.com',
          });
        }
        setTimeout(() => {
          this.fetchRequests();
        }, 2000);
        this.dialogAddRequest = false;
      }
    },
    async addCsvProfileRequests() {
      if (this.$refs.csvRequestsForm.validate()) {
        if (!this.template) {
          this.$notify({
            type: 'error',
            title: 'Error',
            text: 'Please select a template',
          });
          return;
        }

        if (!this.csvRequests.length) {
          this.$notify({
            type: 'error',
            title: 'Error',
            text: 'Please select a CSV file',
          });
          return;
        }

        if (this.message) {
          this.csvRequests.forEach(request => {
            request.note = this.message;
          });
        }

        const csvRequestsObject = {
          organizatonId: this.organization.id,
          accountId: this.account.accountId,
          templateId: this.template,
          requests: this.csvRequests,
        };

        try {
          await this.$store.dispatch(CREATE_REQUESTS_CSV, csvRequestsObject);
          this.$notify({
            type: 'success',
            title: 'Success',
            text: 'Requests from CSV file created',
          });
          this.dialogAddRequestsCsv = false;
          this.fetchRequests();
        } catch(err) {
          this.$notify({
            type: 'error',
            title: 'Error',
            text: 'Something went wrong - please contact support@planetverify.com',
          });
        }
      }
    },
  },
  async mounted() {
    await this.$store.dispatch(CHECK_ORGANIZATIONS);
    this.selectedUsers = this.selectedStoreUsers;
    this.selectedUsersModel = [...this.selectedUsers];
    this.selectedStatuses = this.selectedStoreStatuses.includes(1) || this.selectedStoreStatuses.includes(3) ? this.selectedStoreStatuses : [];
    this.datesRelativeSelected = this.selectedStoreDate === 0 ? 0 : this.selectedStoreDate || 43200;
    await this.fetchRequests();

    // Deselect user from filter if no requests created by this user
    if (this.selectedUsers.length === 1 && !this.requestsStore.find(request => request.requesterId === this.selectedUsers[0])) {
      this.selectedUsers = [];
    }

    this.filterRequests();
    if (!this.$store.getters.isProfileRequestViewer) {
      this.$router.push({ name: 'Restrict' });
    }
    this.search = this.filterText;
    if (!this.templates.length) {
      try {
        await this.$store.dispatch(GET_TEMPLATES, this.account.accountId);
      } catch(err) {
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Error getting templates. Please contact support@planetverify.com',
        });
      }
    }
    try {
      const response = await this.$store.dispatch(GET_CREDITS, this.organization.id);
      this.credits = response.availableCredits;
    } catch(err) {
      this.$notify({
        type: 'error',
        title: 'Error',
        text: 'Something went wrong - please contact support@planetverify.com',
      });
    }
  },
}
</script>

<style>
.requests-switcher .v-btn::before {
  content: none;
}
.requests-switcher .v-btn,
.requests-switcher .v-btn:hover,
.requests-switcher .v-btn.v-btn--active {
  background: none !important;
  font-weight: 500;
}
.requests-switcher.v-btn-toggle--group .v-btn.v-btn--contained {
  font-size: 1rem!important;
  padding: 0 !important;
  color: #2196f3;
  margin: 0 20px 0 0 !important;
  border-bottom: 2px solid transparent;
  border-top: 2px solid transparent;
  border-width: 2px 0 2px 0;
  min-width: 0 !important;
}
.requests-switcher .v-btn.v-btn--active {
  color: #000 !important;
  border-bottom-color: #000 !important; 
}
select.form-control[size], select.form-control[multiple] {
  height: 28px !important;
}
.new-request-btn {
  margin-right: 1px;
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
.new-request-btn:not([disabled]) {
  color: #fff;
}
.new-request-btn-dropdown {
  min-width: 30px !important;
  padding: 0 8px !important;
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}
.new-request-btn-dropdown:not([disabled]) {
  color: #fff;
}
.files-size-exceeded {
  color: #F44336;
}
.csv-file-input {
  position: relative;
  cursor: pointer;
}
.csv-file-input input {
  position: absolute;
  z-index: -1;
  opacity: 0;
}
.csv-file-button {
  align-items: center;
  background-color: #efefef;
  color: rgba(0,0,0,0.87);
  padding: 0 16px;
  text-transform: uppercase;
  font-size: 14px;
  font-weight: 500;
  height: auto !important;
}
.csv-file-button .v-icon {
  margin-right: 10px;
  color: rgba(0,0,0,0.87);
}
.csv-file-error {
  color: #ff5252;
  font-style: italic;
}
.requests-action-buttons {
  margin-bottom: -44px;
  max-width: calc(100% - 387px);
}
.requests-list-table td > a {
  display: block;
  margin: 0 -16px;
  padding: 16px;
  text-decoration: none;
  white-space: nowrap;
  color: rgba(0,0,0,.87);
  min-height: 100%;
}
</style>
